/** @format */

import React from 'react';
import './styles.scss';

export const FILTER_KEYS = {
  ALL: 'all',
  COMING: 'coming',
  FOR_SALE: 'for_sale',
  SOLD: 'sold'
};

export default function SearchFilterPanel(props) {
  const { filteringData, setFilteringData } = props;
  const filterClickHandler = (filter) => {
    setFilteringData((prevState) => {
      return {
        ...prevState,
        statuses: filter !== 'all' ? [filter] : []
      };
    });
  };

  const FilterItem = ({ text, isActive = false, filterKey }) => (
    <span
      className={isActive ? 'active' : ''}
      onClick={() => filterClickHandler(filterKey)}>
      {text}
    </span>
  );

  return (
    <div className='search-filter-panel'>
      <FilterItem
        filterKey={FILTER_KEYS.ALL}
        text={props.t('lang_common:object_listing:search_filter:all:text')}
        isActive={filteringData.statuses.length === 0}
      />
      <FilterItem
        filterKey={FILTER_KEYS.COMING}
        text={props.t(
          'lang_common:object_listing:property_status:upcoming:text'
        )}
        isActive={filteringData.statuses.includes(FILTER_KEYS.COMING)}
      />
      <FilterItem
        filterKey={FILTER_KEYS.FOR_SALE}
        text={props.t('lang_common:object_listing:search_filter:for_sale:text')}
        isActive={filteringData.statuses.includes(FILTER_KEYS.FOR_SALE)}
      />
      <FilterItem
        filterKey={FILTER_KEYS.SOLD}
        text={props.t('lang_common:object_listing:search_filter:sold:text')}
        isActive={filteringData.statuses.includes(FILTER_KEYS.SOLD)}
      />
    </div>
  );
}
